<template>
  <v-row justify="center" class="user-edit">
    <v-col cols="11" sm="8" md="6" lg="5" xl="4" class="pt-8">
      <v-btn
        exact
        outlined
        color="deep-orange"
        class="mb-4"
        :to="{ name: CustomerRoutes.ORDERS_INDEX }"
        ><v-icon small left>mdi-arrow-left</v-icon>Back to My Orders</v-btn
      >
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5" outlined>
            <v-card-title>
              <h2 class="text-h4 mb-4">Account Details</h2>
            </v-card-title>
            <v-card-text>
              <div
                v-if="loading"
                class="text-center grey--text text--darken-2 mt-4"
                key="loading-settings"
              >
                <h2 class="mt-2">Loading Settings</h2>
                <v-progress-circular
                  indeterminate
                  class="mt-4"
                  color="grey darken-2"
                  size="20"
                  width="2"
                />
              </div>
              <CustomerEditForm v-else />
            </v-card-text>
            <v-col>
              <transition name="fade" mode="out-in">
                <v-alert v-if="updated" dense text type="success"
                  >Successfully Updated</v-alert
                >
              </transition>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { CustomerRoutes } from '@/constants/RouteNames'
import { mapActions } from 'vuex'

import CustomerEditForm from '@/components/CustomerEditForm'

export default {
  name: 'CustomerEditView',
  components: { CustomerEditForm },
  props: {},
  data() {
    return {
      loading: false,
      working: false,
      updated: false,
      error: null,
      CustomerRoutes,
    }
  },
  methods: {
    ...mapActions('auth', ['fetchAuthCustomer']),
  },
  async created() {
    this.loading = true
    try {
      await this.fetchAuthCustomer()
    } catch (error) {
      this.error = true
    } finally {
      this.loading = false
    }
  },
}
</script>
